export default __webpack_public_path__ + "static/media/residencial.23d4b437.svg";